// !IMPORTANT NOTE:
// there is a duplication in data
// NotPurchasedReasonEnum is actually the merged version of 2 other enums
// but merging 2 enum was much more complicated than duplicating the data

export enum NotPurchasedMissingCustomerLockedEnum {
  CustomerStockFullOurProduct = 'CUSTOMER_STOCK_FULL_OUR_PRODUCT',
  CustomerStockFullCompetitorsProduct = 'CUSTOMER_STOCK_FULL_COMPETITORS_PRODUCT',
  OurServiceDidNotSatisfy = 'OUR_SERVICE_DID_NOT_SATISFY',
  CouldNotReachCustomer = 'COULD_NOT_REACH_CUSTOMER',
  LongPaymentPeriod = 'LONG_PAYMENT_PERIOD',
  PriceDifferenceWithCompetitors = 'PRICE_DIFFERENCE_WITH_COMPETITORS',
  NotInterestedToWorkWithUs = 'NOT_INTERESTED_TO_WORK_WITH_US',
  InsufficientStock = 'INSUFFICIENT_STOCK',
  OldPrice = 'OLD_PRICE',
  CustomerIsLocked = 'CUSTOMER_IS_LOCKED',
  MarketLocked = 'MARKET_LOCKED',
  ProductLocked = 'PRODUCT_LOCKED',
  Other = "OTHER",
}

export enum NotPurchasedCustomerLockedEnum {
  CustomerIsLocked = "CUSTOMER_IS_LOCKED",
}

export enum NotPurchasedReasonEnum {
  CustomerStockFullOurProduct = NotPurchasedMissingCustomerLockedEnum.CustomerStockFullOurProduct,
  CustomerStockFullCompetitorsProduct = NotPurchasedMissingCustomerLockedEnum.CustomerStockFullCompetitorsProduct,
  OurServiceDidNotSatisfy = NotPurchasedMissingCustomerLockedEnum.OurServiceDidNotSatisfy,
  CouldNotReachCustomer = NotPurchasedMissingCustomerLockedEnum.CouldNotReachCustomer,
  LongPaymentPeriod = NotPurchasedMissingCustomerLockedEnum.LongPaymentPeriod,
  PriceDifferenceWithCompetitors = NotPurchasedMissingCustomerLockedEnum.PriceDifferenceWithCompetitors,
  NotInterestedToWorkWithUs = NotPurchasedMissingCustomerLockedEnum.NotInterestedToWorkWithUs,
  InsufficientStock = NotPurchasedMissingCustomerLockedEnum.InsufficientStock,
  OldPrice = NotPurchasedMissingCustomerLockedEnum.OldPrice,
  CustomerIsLocked = NotPurchasedMissingCustomerLockedEnum.CustomerIsLocked,
  MarketLocked = NotPurchasedMissingCustomerLockedEnum.MarketLocked,
  ProductLocked = NotPurchasedMissingCustomerLockedEnum.ProductLocked,
  Other = NotPurchasedMissingCustomerLockedEnum.Other,
}
